import { CredentialEntity, MicrosoftCredentialToCredentialEntityMapper } from '@uploadcam/common';
import { ExchangeAuthCodeInteractor } from '../../auth/domain/interactors/exchange-auth-code.interactor';

export class ExchangeMicrosoftAuthCodeInteractor implements ExchangeAuthCodeInteractor {
  constructor(
    private readonly clientId: string,
    private readonly redirectUri: string,
    private readonly scopes: string[],
  ) {}

  public async execute(code: string, verifier: string): Promise<CredentialEntity> {
    const mapper = new MicrosoftCredentialToCredentialEntityMapper(Date.now());
    const res = await fetch(`https://login.microsoftonline.com/common/oauth2/v2.0/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: this.clientId,
        scope: this.scopes.join(' '),
        code: code,
        redirect_uri: this.redirectUri,
        code_verifier: verifier,
      }),
    });

    return mapper.map(await res.json());
  }
}
